import type { VfConfig } from '#types/config/components/vf'

export default {
  alwaysUseGrid: true,
  brandClasses: {
    carousel: 'gap-1 <lg:grid'
  },
  showPagination: false
} satisfies VfConfig['mediaGallery']
